<div 
  class="toast-container" 
  #toastContainer
  [ngStyle]="getContainerStyle()"
  [class.dragging]="isDragging"
  (mousedown)="onDragStart($event)"
>
  <div
    *ngFor="let task of tasks"
    class="toast-item"
    [ngClass]="'toast-' + task.status"
  >
    <!-- Header -->
    <div class="toast-header" [class.draggable]="true">
      <div class="toast-icon">
        <span
          *ngIf="task.status === 'running'"
          class="spinner-border spinner-border-sm"
          role="status"
        ></span>
        <i
          *ngIf="task.status === 'success'"
          class="fas fa-check-circle text-success"
        ></i>
        <i
          *ngIf="task.status === 'error'"
          class="fas fa-times-circle text-danger"
        ></i>
      </div>
      <span class="toast-title">{{ task.title }}</span>
      <span class="drag-hint" title="Arraste para mover">
        <i class="fas fa-grip-vertical"></i>
      </span>
    </div>

    <!-- Body -->
    <div class="toast-body">
      <!-- Running state -->
      <ng-container *ngIf="task.status === 'running'">
        <p class="toast-message">{{ task.message }}</p>
        <button
          *ngIf="task.returnRoute"
          type="button"
          class="btn btn-sm btn-outline-primary mt-2"
          (click)="navigateToPage(task)"
        >
          <i class="fas fa-arrow-left me-1"></i>
          {{ task.returnLabel || "Voltar para a página" }}
        </button>
      </ng-container>

      <!-- Completed state (success) -->
      <ng-container *ngIf="task.status === 'success'">
        <div class="completion-state success-state">
          <i class="fas fa-check-circle completion-icon"></i>
          <p class="completion-message">{{ task.message }}</p>
          <button
            type="button"
            class="btn btn-success btn-sm mt-2"
            (click)="dismissTask(task.id)"
          >
            <i class="fas fa-times me-1"></i>
            Fechar
          </button>
        </div>
      </ng-container>

      <!-- Error state -->
      <ng-container *ngIf="task.status === 'error'">
        <div class="completion-state error-state">
          <i class="fas fa-times-circle completion-icon"></i>
          <p class="completion-message">{{ task.message }}</p>
          <button
            type="button"
            class="btn btn-danger btn-sm mt-2"
            (click)="dismissTask(task.id)"
          >
            <i class="fas fa-times me-1"></i>
            Fechar
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
